interface StoreApi {
    get<T = unknown>(key: string): T | null;
    set(key: string, value: unknown): void;
    remove(key: string): void;
    each(callback: (value: unknown, key: string) => void): void;
}

function getStorage(): Storage | null {
    if (typeof window === 'undefined') {
        return null;
    }

    try {
        return window.localStorage;
    } catch {
        return null;
    }
}

function parseValue<T>(value: string | null): T | null {
    if (value == null) {
        return null;
    }

    try {
        return JSON.parse(value) as T;
    } catch {
        return value as T;
    }
}

const localStore: StoreApi = {
    get<T = unknown>(key: string): T | null {
        const storage = getStorage();

        if (!storage) {
            return null;
        }

        return parseValue<T>(storage.getItem(key));
    },
    set(key: string, value: unknown): void {
        const storage = getStorage();

        if (!storage) {
            return;
        }

        storage.setItem(key, JSON.stringify(value));
    },
    remove(key: string): void {
        const storage = getStorage();

        if (!storage) {
            return;
        }

        storage.removeItem(key);
    },
    each(callback: (value: unknown, key: string) => void): void {
        const storage = getStorage();

        if (!storage) {
            return;
        }

        for (let index = 0; index < storage.length; index += 1) {
            const key = storage.key(index);

            if (!key) {
                continue;
            }

            callback(parseValue(storage.getItem(key)), key);
        }
    },
};

export default localStore;
